<h3 *ngIf="title" class="accordion-title">{{ title }}</h3>
<ngb-accordion>
  <ngb-panel id="static-{{ i }}" *ngFor="let item of safeItems; let i = index">
    <ng-template ngbPanelTitle>
      <span [innerHTML]="item.title"></span>
    </ng-template>

    <ng-template ngbPanelContent>
      <div [innerHTML]="item.body"></div>
    </ng-template>
  </ngb-panel>
</ngb-accordion>
